<template>
    <div class="envq-root">
        <main class="detailContainer grid">
            <!-- 左侧：筛选 + 简介 + 轮播 -->
            <section class="grid" style="gap:24px">
                <!-- 控件 -->
                <div class="card pad">
                    <div class="controls">
                        <!-- 模块类型（分段按钮，来自 details.list） -->
                        <div class="field">
                            <label class="muted" style="font-size:13px">模块类型</label>
                            <div class="seg">
                                <button
                                        v-for="(g,i) in groups"
                                        :key="g.groupName || g.title || i"
                                        :class="{ active: i === groupIndex }"
                                        @click="setGroup(i)"
                                >
                                    {{ g.groupName || g.title || ('分组'+(i+1)) }}
                                </button>
                            </div>
                        </div>

                        <!-- 日期（单日） -->
                        <div class="field">
                            <label class="muted" style="font-size:13px">监测日期</label>
                            <div class="row">
                                <button class="chip ghost" @click="prevDate" title="前一天"></button>
                                <input type="date" v-model="date" @change="onDateChange"/>
                                <button class="chip ghost" @click="nextDate" title="后一天"></button>
                                <button class="chip" @click="setToday">今天</button>
                                <button class="chip ghost" @click="setYesterday">昨天</button>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- 轮播（直接消费 details.list[groupIndex].urls） -->
                <div class="card pad">
                    <div class="carousel" @mouseenter="pause" @mouseleave="play">

                        <img
                                v-if="current.images.length && current.images[idx].value"
                                :src="current.images[idx].value | imgUrl(2)"
                                :alt="'slide-'+idx"
                                @click="openPreview(idx)"
                        />
                        <img
                                v-else-if="current.images.length && current.images[idx].sourceUrl"
                                :src="current.images[idx].sourceUrl"
                                :alt="'slide-'+idx"
                                @click="openPreview(idx)"
                        />
                        <div v-else class="muted" style="padding:24px;text-align:center">暂无图片</div>

                        <button class="nav left" @click="prev" v-if="current.images.length"></button>
                        <button class="nav right" @click="next" v-if="current.images.length"></button>

                        <div class="dots" v-if="current.images.length">
                            <div
                                    v-for="(img,i) in current.images"
                                    :key="'dot-'+i"
                                    class="dot"
                                    :class="{active:i===idx}"
                                    @click="goto(i)"
                            ></div>
                        </div>

                        <div class="switch" v-if="current.images.length">
                            <button class="btn ghost" @click="toggleAuto">{{ autoPlay? '暂停轮播':'播放轮播' }}</button>
                        </div>
                    </div>
                </div>


                <!-- 预览灯箱 -->
                <div v-if="previewOpen" class="lightbox" @click.self="closePreview">
                    <div class="lb-wrap">
                        <button class="lb-arrow left" @click.stop="prevPreview">◀</button>
                        <button class="lb-arrow right" @click.stop="nextPreview">▶</button>
                        <div class="lb-card">
                            <div class="lb-top">
                                <div>
                                    <div class="lb-title">{{ current.title }}</div>
                                    <div class="lb-meta">{{ date }} · 第 {{ previewIdx+1 }} / {{ current.images.length }} 张</div>
                                </div>
                                <button class="lb-btn lb-close" @click="closePreview">关闭</button>
                            </div>
                            <img
                                    class="lb-img"
                                    v-if="current.images[previewIdx].value"
                                    :src="current.images[previewIdx].value | imgUrl(2)"
                                    :alt="'preview-'+previewIdx"
                            />
                            <img
                                    class="lb-img"
                                    v-else
                                    :src="current.images[previewIdx].sourceUrl"
                            :alt="'preview-'+previewIdx"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <!-- 右侧：解读区（“我的 / 他人”） -->
            <aside class="grid" style="gap:24px">
                <div class="card pad">
                    <div style="display:flex;align-items:center;justify-content:space-between">
                        <div style="font-weight:600">模块解读</div>
                        <div class="tabs">
                            <button :class="{active:tab==='mine'}" @click="tab='mine'">解读</button>
                            <button :class="{active:tab==='others'}" @click="otherClick()">我的</button>
                        </div>
                    </div>

                    <div v-if="tab==='mine'" style="margin-top:12px">
            <textarea
                    v-model="mine"
                    :placeholder="userName ? '我要解读' : '登录后可发表解读！'"
                    :disabled="!userName || !currentImgId"
            ></textarea>
                        <div class="actions">
                            <div class="muted" style="font-size:12px">可见范围：仅自己可见</div>
                            <button class="chip" @click="save" :disabled="!userName || !currentImgId">保存解读</button>
                        </div>
                        <div v-if="saved" style="color:#059669;font-size:12px;margin-top:8px">已保存 ✓</div>
                    </div>

                    <div v-else class="list">
                        <div v-if="!others" class="cmt">
                            暂无解读内容
                        </div>
                        <div v-else v-for="o in others" :key="o.id" class="cmt">
                            <div class="head">
                                <div class="avatar">{{$store.state.userName.slice(1,2) }}</div>
                                <div style="font-weight:500">{{$store.state.userName }}</div>
                            </div>
                            <div>{{ o.content }}</div>
<!--                            <div class="c-meta">-->
<!--                                <button class="btn ghost" @click="o.likes++">👍 赞同 {{ o.likes }}</button>-->
<!--                                <button class="btn ghost">💬 评论</button>-->
<!--                                <button class="btn ghost">↗ 引用</button>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>

                <div class="card pad">
                    <div style="font-weight:600;margin-bottom:6px">使用提示</div>
                    <ul class="muted" style="padding-left:16px;margin:0">
                        <li>监测日期为“单日选择”，支持一键选择“今天 / 昨天”。</li>
                        <li>轮播支持自动播放、悬停暂停、指示点跳转与左右切换。</li>
                    </ul>
                </div>

                <!-- 简介（来自 menuInfo + 当前分组名兜底） -->
                <div class="card pad">
                    <div class="intro">
                        <div class="badge">i</div>
                        <div>
                            <div style="font-weight:600;margin-bottom:4px">{{ current.title }}</div>
                            <div class="muted" v-html="current.desc"></div>
                        </div>
                    </div>
                </div>
            </aside>
        </main>
    </div>
</template>

<script>
    import UrlApi from "@/utils/UrlApi.js";

    export default {
        name: "EnvQualityDetail",
        data() {
            const fmt = (d) => {
                if (!d) return "";
                const dt = (d instanceof Date) ? d : new Date(d);
                const y = dt.getFullYear();
                const m = String(dt.getMonth() + 1).padStart(2, "0");
                const da = String(dt.getDate()).padStart(2, "0");
                return `${y}-${m}-${da}`;
            };
            const today = new Date();

            return {
                // 接口数据
                imgRoot: UrlApi.imgIconRoot,
                details: null,      // { version?, list:[{groupName, urls: [...]}, ...] }
                menuInfo: null,     // { title/name, synopsis }

                // 日期
                date: fmt(today),

                // 当前分组索引 & 轮播
                groupIndex: 0,
                idx: 0,
                autoPlay: true,
                timer: null,

                // 解读
                tab: "mine",
                mine: "",
                saved: false,
                others: [],

                // 预览灯箱
                previewOpen: false,
                previewIdx: 0,

                // util
                formatDate: fmt,

                // 分页（他人解读）
                pageParam: {
                    page: 1,
                    pageSize: 10,
                    totalPage: 0,
                    total: 0
                },
            };
        },
        computed: {
            groups() {
                return (this.details && Array.isArray(this.details.list)) ? this.details.list : [];
            },
            userName() {
                return this.$store.getters.getUserName;
            },
            gpsState() {
                return this.$store.getters.getGpsState || {};
            },
            // 当前分组 + 标题/简介
            current() {
                const has = this.details && Array.isArray(this.details.list) && this.details.list.length > 0;
                const grp = (has && this.details.list[this.groupIndex]) || { groupName: "", urls: [] };
                const images = Array.isArray(grp.urls) ? grp.urls : [];

                const titleFromMenu = (this.menuInfo && (this.menuInfo.title || this.menuInfo.name)) || "";
                const title = titleFromMenu || grp.groupName || "环境质量";
                const desc = (this.menuInfo && this.menuInfo.synopsis) || "";

                return { title, desc, images };
            },
            // 当前图片 id（用于解读关联）
            currentImgId() {
                const img = this.current.images[this.idx];
                if (!img) return null;
                // v2: { id, url/base64 } ; v1: { id?, value }
                return img.id || null;
            },
        },
        mounted() {
            this.fetchAll();
            this.play();
            window.addEventListener("keydown", this.handleKey);
        },
        beforeDestroy() {
            this.pause();
            window.removeEventListener("keydown", this.handleKey);
        },
        methods: {
            // —— 动态分组切换 ——
            setGroup(i) {
                this.groupIndex = i;
                this.idx = 0; // 切组重置轮播位置
                this.play();
            },

            // ===== 原页面数据接入（仅保留“动态 details.list”） =====
            fetchAll() {
                this.fetchDetails();
                this.fetchMenuInfo();
            },
            fetchDetails() {
                const id = this.$route.query.id;
                const params = {
                    menuId: id,
                    nowDate: this.date,
                    area: this.gpsState.area,
                    city: this.gpsState.city,
                    fileType: "image",
                };
                this.$http.get(UrlApi.detailsUrl, { params }).then((res) => {
                    this.details = res.data.data;
                    // v1：让每组 urls 最新在前（保持与老页一致）
                    if (this.details && this.details.list && this.details.version != 2) {
                        this.details.list.forEach((g) => {
                            if (g && g.urls && g.urls.length > 1) g.urls = g.urls.slice().reverse();
                        });
                    }
                    // 入参切换后重置
                    this.groupIndex = 0;
                    this.idx = 0;
                    this.getGraphicIdeaList()
                });
            },
            fetchMenuInfo() {
                const id = this.$route.query.id;
                this.$http.get(UrlApi.menuInfo, { params: { menuId: id } }).then((res) => {
                    this.menuInfo = res.data.data;
                });
            },

            // ===== 轮播 =====
            clamp(i) {
                const len = (this.current.images && this.current.images.length) || 1;
                return (i + len) % len;
            },
            next() { if (this.current.images.length) this.idx = this.clamp(this.idx + 1); },
            prev() { if (this.current.images.length) this.idx = this.clamp(this.idx - 1); },
            goto(i) { if (this.current.images.length) this.idx = this.clamp(i); },
            play() {
                this.pause();
                if (this.autoPlay && this.current.images.length) {
                    this.timer = setInterval(this.next, 3500);
                }
            },
            pause() {
                if (this.timer) { clearInterval(this.timer); this.timer = null; }
            },
            toggleAuto() {
                this.autoPlay = !this.autoPlay;
                this.autoPlay ? this.play() : this.pause();
            },


            // 日期
            setToday() { this.date = this.formatDate(new Date()); this.onDateChange(); },
            setYesterday() { const d = new Date(); d.setDate(d.getDate() - 1); this.date = this.formatDate(d); this.onDateChange(); },
            addDays(baseStr, n) { const d = baseStr ? new Date(baseStr) : new Date(); d.setDate(d.getDate() + n); return this.formatDate(d); },
            prevDate() { this.date = this.addDays(this.date, -1); this.onDateChange(); },
            nextDate() { this.date = this.addDays(this.date, 1); this.onDateChange(); },
            onDateChange() {
                this.fetchDetails();
                this.idx = 0;
            },

            // 他人解读
            otherClick() {
                this.tab = 'others';
                this.getGraphicIdeaList();
            },
            getGraphicIdeaList() {
                let token = this.$store.getters.getToken;
                let url = UrlApi.graphicIdea;
                let userId = this.$store.getters.getUserId;
                let params = {
                    userId: userId,
                    cyDataId: this.currentImgId, // 动态取当前图片 id
                    page: this.pageParam.page,
                    pageSize: this.pageParam.pageSize
                };
                this.$http.get(url, {
                    params,
                    headers: { 'Authorization': token },
                }).then((res) => {
                    console.log(res)
                    this.others = res.data.data.list;
                    this.pageParam.totalPage = res.data.data.pageInfo.totalPage;
                    this.pageParam.total = res.data.data.pageInfo.total;
                });
            },

            // 解读（我的）
            save() {
                if (!this.userName || !this.currentImgId) return;
                const url = UrlApi.saveGraphicIdea;
                const userId = this.$store.getters.getUserId;
                const param = `userId=${userId}&content=${encodeURIComponent(this.mine || "")}&cyDataId=${this.currentImgId}`;
                this.$http.post(url, param, {
                    headers: {
                        Authorization: this.$store.getters.getToken,
                        "content-type": "application/x-www-form-urlencoded"
                    }
                }).then((res) => {
                    if (res.data && res.data.success) {
                        this.saved = true;
                        setTimeout(() => (this.saved = false), 1500);
                    }
                });
            },

            // 预览灯箱
            openPreview(i) {
                if (!this.current.images.length) return;
                this.previewIdx = typeof i === "number" ? this.clamp(i) : this.idx;
                this.previewOpen = true;
                this.pause();
            },
            closePreview() {
                this.previewOpen = false;
                this.play();
            },
            nextPreview() { this.previewIdx = this.clamp(this.previewIdx + 1); },
            prevPreview() { this.previewIdx = this.clamp(this.previewIdx - 1); },
            handleKey(e) {
                if (!this.previewOpen) return;
                if (e.key === "Escape") this.closePreview();
                if (e.key === "ArrowRight") this.nextPreview();
                if (e.key === "ArrowLeft") this.prevPreview();
            },
        },
    };
</script>

<style>
    /* —— 保持你新页面的样式不变 —— */
    :root{
        --c-bg:#f8fafc; /* slate-50 */
        --c-card:#ffffff;
        --c-border:#e2e8f0; /* slate-200 */
        --c-text:#0f172a; /* slate-900 */
        --c-muted:#64748b; /* slate-500 */
        --c-primary:#0284c7; /* sky-600 */
        --c-primary-50:#f0f9ff;
        --radius:16px;
        --shadow:0 8px 24px rgba(2,8,23,.06);
    }
    *{box-sizing:border-box}
    .envq-root{
        min-height: calc(100% - 34px);
        margin:0;background:linear-gradient(#fff,var(--c-bg));color:var(--c-text);
        font:14px/1.6 system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,'Noto Sans',"Apple Color Emoji","Segoe UI Emoji"}
    .detailContainer{max-width:1440px;margin:0 auto;padding:24px}
    header{position:sticky;top:0;z-index:10;background:rgba(255,255,255,.8);backdrop-filter:blur(8px);border-bottom:1px solid var(--c-border)}
    header .wrap{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:12px 24px;margin:0 auto;max-width:1440px}
    .brand{display:flex;align-items:center;gap:12px}
    .brand-badge{width:36px;height:36px;border-radius:12px;display:grid;place-items:center;background:#0f172a;color:#fff;box-shadow:var(--shadow)}
    .muted{color:var(--c-muted)}
    .grid{display:grid;gap:24px}
    main.detailContainer.grid{align-items:start}
    @media(min-width:1200px){main.detailContainer.grid{grid-template-columns:minmax(0,1fr) 380px}}
    @media(min-width:1600px){main.detailContainer.grid{grid-template-columns:minmax(0,1fr) 420px}}
    .card{background:var(--c-card);border:1px solid var(--c-border);border-radius:var(--radius);box-shadow:var(--shadow)}
    .card.pad{padding:16px}

    /* 控件 */
    .controls{display:grid;gap:16px}
    @media(min-width:720px){.controls{grid-template-columns:1fr 1fr}}
    .seg{display:flex;gap:8px;padding:6px;background:#f1f5f9;border:1px solid var(--c-border);border-radius:14px;flex-wrap:wrap}
    .seg button{padding:6px 12px;border:1px solid transparent;border-radius:10px;background:transparent;cursor:pointer}
    .seg button.active{background:#fff;border-color:var(--c-border);box-shadow:0 2px 8px rgba(2,8,23,.05)}
    .field{display:flex;flex-direction:column;gap:6px}
    .row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
    input[type="date"]{padding:8px 10px;border:1px solid var(--c-border);border-radius:12px;background:#fff;min-width:180px}
    .chip{border:1px solid #bae6fd;background:#e0f2fe;color:#0369a1;border-radius:999px;padding:6px 10px;cursor:pointer}
    .chip.ghost{背景:#fff;border-color:var(--c-border);color:var(--c-muted)}

    /* 简介 */
    .intro{display:flex;gap:14px}
    .intro .badge{width:40px;height:40px;border-radius:14px;background:#e0f2fe;
        color:#333;display:grid;place-items:center;box-shadow:var(--shadow)}

    /* 轮播 */

    /* 仅用 CSS 覆盖，保持你的业务逻辑与模板不变 */
    .envq-root .carousel img {
        width: 100% !important;     /* 容器宽度自适应 */
        height: auto !important;     /* 高度跟随图片等比缩放 */
        aspect-ratio: auto !important;
        max-height: none !important; /* 去掉统一的720px上限 */
        object-fit: contain !important; /* 防止拉伸或裁切（可要可不要） */
        display: block;              /* 消除行内元素空隙影响 */
    }

    /* 可选：避免图片未加载时容器高度为0导致跳动，给个温柔的占位高度 */
    .envq-root .carousel {
        /* 需要的话可以设置一个最小高度做占位（数值可按需调整或移除） */
        /* min-height: 200px; */
        overflow: hidden;  /* 你原本就有，保留即可 */
        padding: 4px;
    }


    .carousel{position:relative;border-radius:14px;overflow:hidden}
    .carousel img{
        width:100%;
        height:auto;
        aspect-ratio:16/9;max-height:720px;object-fit:cover;display:block;cursor:zoom-in}
    .nav{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.85);backdrop-filter:blur(6px);border:1px solid var(--c-border);padding:6px 10px;border-radius:12px;cursor:pointer}
    .nav.left{left:12px}
    .nav.right{right:12px}
    .dots{position:absolute;left:0;right:0;bottom:12px;display:flex;justify-content:center;gap:8px}
    .dot{height:10px;width:10px;border-radius:999px;background:rgba(255,255,255,.8);border:1px solid var(--c-border);cursor:pointer}
    .dot.active{width:24px;background:#0ea5e9}
    .switch{position:absolute;right:12px;top:12px}

    /* 预览灯箱 */
    .lightbox{position:fixed;
        inset:0;background:rgba(2,6,23,.7);backdrop-filter:blur(2px);display:flex;align-items:center;
        justify-content:center;padding:24px;z-index:9999}
    .lb-wrap{position:relative;width:min(1100px,96vw)}
    .lb-card{background:#fff;border:1px solid var(--c-border);border-radius:16px;box-shadow:var(--shadow);overflow:hidden}
    .lb-top{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-bottom:1px solid var(--c-border)}
    .lb-title{font-weight:600}
    .lb-meta{color:#475569;font-size:12px}
    .lb-img{width:100%;max-height:78vh;object-fit:contain;background:#000}
    .lb-actions{display:flex;gap:8px;padding:10px 14px;border-top:1px solid var(--c-border)}
    .lb-btn{padding:8px 12px;border-radius:12px;border:1px solid var(--c-border);background:#fff;cursor:pointer}
    .lb-close{border:none;background:#0f172a;color:#fff}
    .lb-arrow{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.9);border:1px solid var(--c-border);padding:8px 12px;border-radius:12px;cursor:pointer}
    .lb-arrow.left{left:-56px}
    .lb-arrow.right{right:-56px}
    @media(max-width:640px){.lb-arrow.left{left:8px}.lb-arrow.right{right:8px}}

    /* 解读 */
    .tabs{display:flex;gap:6px;background:#f1f5f9;border:1px solid var(--c-border);border-radius:12px;padding:6px}
    .tabs button{padding:6px 12px;border-radius:10px;background:transparent;border:1px solid transparent;cursor:pointer}
    .tabs button.active{background:#fff;border:1px solid var(--c-border);box-shadow:0 2px 8px rgba(2,8,23,.05)}
    textarea{width:100%;min-height:160px;padding:10px;border:1px solid var(--c-border);border-radius:12px}
    .actions{display:flex;justify-content:space-between;align-items:center;margin-top:8px}
    .btn{padding:8px 12px;
        border-radius:12px;border:1px solid transparent;background:var(--c-primary);color:#fff;cursor:pointer}
    .btn.ghost{background:#fff;color:#0f172a;border-color:var(--c-border)}
    .list{display:grid;gap:12px;margin-top:12px}
    .cmt{border:1px solid var(--c-border);border-radius:12px;padding:12px}
    .cmt .head{display:flex;align-items:center;gap:10px;margin-bottom:6px}
    .avatar{width:32px;height:32px;border-radius:999px;background:#e2e8f0;display:grid;place-items:center;color:#475569}
    .c-meta{display:flex;gap:8px;color:var(--c-muted);font-size:12px;margin-top:8px}


    /* ===== 统一图标规格（可按需调整） ===== */
    /* —— 轮播左右箭头：确保图标在按钮内完全居中 —— */
    .envq-root .carousel .nav{
        /* 按钮本身 */
        position: absolute;  /* 你原有的定位保留 */
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 0 !important;        /* 避免字符行高干扰 */
        padding: 0 !important;
    }

    .envq-root .carousel .nav::before{
        content: "";
        width: var(--icon-size);
        height: var(--icon-size);
        display: block;
        background-repeat: no-repeat;
        background-position: center center; /* 关键：中心对齐 */
        background-size: contain;           /* 关键：自适应等比 */
    }

    /* 左右两侧各自的 SVG（保留你之前的样式） */
    .envq-root .carousel .nav.left::before{
        background-image: url("data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='15 18 9 12 15 6'/></svg>");
    }
    .envq-root .carousel .nav.right::before{
        background-image: url("data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='9 18 15 12 9 6'/></svg>");
    }

    /* —— 日期“前一天 / 后一天”小按钮：同样强制居中 —— */
    .envq-root .field .row .chip.ghost{
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 0 !important;
        padding: 0 !important;
    }

    .envq-root .field .row > .chip.ghost:first-child::before,
    .envq-root .field .row > .chip.ghost:nth-child(3)::before{
        content: "";
        width: 16px; height: 16px;
        display: block;
        background-repeat: no-repeat;
        background-position: center center; /* 居中 */
        background-size: contain;           /* 等比 */
        opacity: .9;
    }

    /* 左箭头图标 */
    .envq-root .field .row > .chip.ghost:first-child::before{
        background-image: url("data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='15 18 9 12 15 6'/></svg>");
    }
    /* 右箭头图标 */
    .envq-root .field .row > .chip.ghost:nth-child(3)::before{
        background-image: url("data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='9 18 15 12 9 6'/></svg>");
    }

    /* —— 细节稳固：避免 1px 偏移 —— */
    :root{
        --icon-size: 18px;      /* 用偶数像素减少半像素取整误差 */
        --icon-btn-size: 36px;  /* 同上 */
    }
    .envq-root .carousel .nav{
        width: var(--icon-btn-size) !important;
        height: var(--icon-btn-size) !important;
        border-width: 1px !important;       /* 使用整数像素的边框 */
    }


    /* 给轮播留出一个不遮图的“顶部控制条” */
    .envq-root .carousel{
        padding-top: 44px;                 /* 预留高度，按钮放这里 */
    }

    /* 将“暂停/播放”按钮放到顶部控制条里（不覆盖图片） */
    .envq-root .carousel .switch{
        position: absolute !important;
        top: 8px !important;               /* 位于上方内边距区域 */
        right: 12px !important;
        z-index: 2 !important;             /* 在指示点之上，但不挡图片 */
        pointer-events: auto !important;
    }

    /* 按钮样式（保持轻量不抢眼） */
    .envq-root .carousel .switch .btn{
        height: 30px;
        padding: 0 10px;
        border-radius: 10px;
        background: #fff;
        color: var(--c-text);
        border: 1px solid var(--c-border);
        box-shadow: 0 4px 12px rgba(2,8,23,.06);
    }

    /* 小屏时更贴边 */
    @media (max-width:640px){
        .envq-root .carousel{
            padding-top: 40px;
        }
        .envq-root .carousel .switch{ right: 8px; top: 6px; }
    }



</style>
